import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'

import { MaterialModule } from './shared/material.module'
import { BaseSidenavComponent } from './ui-core/base-sidenav/base-sidenav.component'
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field'
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio'
import { MAT_CHECKBOX_DEFAULT_OPTIONS } from '@angular/material/checkbox'

// Auth
import {
	MsalInterceptor,
	MsalInterceptorConfiguration,
	MsalModule,
	MsalRedirectComponent,
	MsalService,
	MSAL_INSTANCE,
	MSAL_INTERCEPTOR_CONFIG,
} from '@azure/msal-angular'
import { InteractionType, PublicClientApplication } from '@azure/msal-browser'
import { config } from '@app/constants/msal-config'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { environment } from 'src/environments/environment'
import { AppState } from './shared/store/app.state'

import { NgxsModule, NGXS_PLUGINS } from '@ngxs/store'
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin'
import { NgxsStoragePluginModule, StorageOption } from '@ngxs/storage-plugin'
import { UserState } from './shared/store/user/user.state'
import { NgxsFormPluginModule } from '@ngxs/form-plugin'
import { LoaderInterceptor } from './shared/loader.interceptor'
import { AssertiveLoaderModule } from './molecules/assertive-loader/assertive-loader.module'
import { DrawerModule } from './molecules/drawer/drawer.module'
import { quoteFlowMetaReducer } from '@app/shared/store/meta-reducers/quote-flow-route.reducer'
import { TitleStrategy } from '@angular/router'
import { TitleResolutionService } from './title-resolution.service'
import { NgxsRouterPluginModule } from '@ngxs/router-plugin'
import { SettingsState } from './shared/store/settings/settings.state'

function MsalInstanceFactory(): PublicClientApplication {
	return new PublicClientApplication(config)
}

function MsalInterceptorConfigFactory(): MsalInterceptorConfiguration {
	const protectedResourceMap = new Map<string, Array<string>>()
	protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', [
		'user.read',
		'mail.send',
		'group.read.all',
		'groupmember.read.all',
		'privilegedaccess.read.azureadgroup',
	])
	protectedResourceMap.set(environment.apiBase, environment.msalProtectedApiScopes)

	return {
		interactionType: InteractionType.Popup,
		protectedResourceMap,
	}
}

@NgModule({
	declarations: [AppComponent, BaseSidenavComponent /*QuotingComponent*/],
	imports: [
		BrowserModule,
		HttpClientModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		MaterialModule,
		// QuoteNavModule,
		DrawerModule,
		AssertiveLoaderModule,
		MsalModule,
		NgxsModule.forRoot([AppState, UserState, SettingsState], {
			developmentMode: !environment.production,
		}),
		NgxsReduxDevtoolsPluginModule.forRoot(),
		NgxsStoragePluginModule.forRoot({ storage: StorageOption.SessionStorage }),
		NgxsFormPluginModule.forRoot(),
		NgxsRouterPluginModule.forRoot(),
	],
	providers: [
		{
			provide: NGXS_PLUGINS,
			useValue: quoteFlowMetaReducer,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: LoaderInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: MsalInterceptor,
			multi: true,
		},
		{
			provide: MSAL_INSTANCE,
			useFactory: MsalInstanceFactory,
		},
		{
			provide: MSAL_INTERCEPTOR_CONFIG,
			useFactory: MsalInterceptorConfigFactory,
		},
		MsalService,
		{
			provide: TitleStrategy,
			useClass: TitleResolutionService,
		},
		{
			provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
			useValue: { appearance: 'outline', floatLabel: 'always' },
		},
		{ provide: MAT_RADIO_DEFAULT_OPTIONS, useValue: { color: 'primary' } },
		{ provide: MAT_CHECKBOX_DEFAULT_OPTIONS, useValue: { color: 'primary' } },
	],
	bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {}
